import React from 'react';
import './medical-form-success-message.scss';
import { useTranslation } from 'react-i18next';
import { Button, ModalFooter, ModalHeader } from 'reactstrap';
import { useCloseOldModal } from '../../../../store/modal/modalHooks';
import MedicalFormSuccessMessageContent from '../MedicalFormSuccessMessageContent';

interface Props {
  successMessage:
    | 'MEDICAL_FORM_APPROVAL_SUCCESS_MESSAGE_CONTENT'
    | 'MEDICAL_FORM_VALID_SUCCESS_MESSAGE_CONTENT';
  noGymTour?: boolean;
}

const MedicalFormSuccessMessage = (props: Props) => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();

  const closeSuccessMessage = () => {
    closeModal();
  };

  return (
    <div className="medical-form-success-message">
      <ModalHeader>
        <p className="form-header-title">{t('MEDICAL_DECLARATION_TITLE')}</p>
      </ModalHeader>
      <div>
        <MedicalFormSuccessMessageContent
          successMessage={props.successMessage}
          noGymTour={props.noGymTour}
        />
      </div>
      <ModalFooter className="medical-form-success-message-buttons" dir="rtl">
        <Button type="button" color="primary" onClick={closeSuccessMessage}>
          {t('MEDICAL_FORM_SUCCESS_MESSAGE_CLOSE_BUTTON')}
        </Button>{' '}
      </ModalFooter>
    </div>
  );
};

export default MedicalFormSuccessMessage;
